const SECURITY_AUTH_PATHS_WITHOUT_BEARER = [
  /^\/auth$/,
  /^\/auth\/two_factor$/,
  /^\/auth\/start$/,
  /^\/reg$/,
  /^\/register\/activate$/,
  /^\/password\/recover$/,
  /^\/password$/,
  /^\/refresh$/,
]

export const hasStoredAuthSession = () => Boolean(localStorage.getItem('refresh_token'))

/** Guest security endpoints must not reuse stale Bearer / switch-user from localStorage. */
export const isSecurityAuthRequestWithoutBearer = (url = '') => {
  const path = url.split('?')[0]

  return SECURITY_AUTH_PATHS_WITHOUT_BEARER.some((pattern) => pattern.test(path))
}
